import { useEffect, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setUserReturnedFromUpiApp } from '../redux/appConfigInfo';

const MIN_HIDDEN_MS = 2000;

const useDetectWebPageVisibility = (onReturnCallback = () => {}) => {
  const dispatch = useDispatch();
  const { isWaitingForUpiApp } = useSelector((state) => state.appConfigInfo);

  const wasHidden = useRef(false);
  const hiddenAt = useRef(null);

  const handleVisibilityChange = useCallback(() => {
    if (document.visibilityState === 'hidden') {
      wasHidden.current = true;
      hiddenAt.current = Date.now();
    } else if (document.visibilityState === 'visible' && wasHidden.current) {
      const timeHidden = hiddenAt.current ? Date.now() - hiddenAt.current : 0;

      // Ignore brief hides caused by window.open tab switching
      if (timeHidden < MIN_HIDDEN_MS) return;

      wasHidden.current = false;
      hiddenAt.current = null;

      if (isWaitingForUpiApp) {
        dispatch(setUserReturnedFromUpiApp(true));
        if (onReturnCallback) {
          onReturnCallback();
        }
      }
    }
  }, [isWaitingForUpiApp, dispatch, onReturnCallback]);

  useEffect(() => {
    // Only listen if Redux says we are actually in a payment flow
    if (isWaitingForUpiApp) {
      document.addEventListener('visibilitychange', handleVisibilityChange);
    }

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isWaitingForUpiApp, handleVisibilityChange]);
};

export default useDetectWebPageVisibility;